<template>
  <div class="card-with-line-container">
    <line-block/>
    <main-title :font-family="fontFamily">
      {{ item.title }}
    </main-title>
  </div>
</template>

<script>
import LineBlock from "@/components/shared/LineBlock.vue";
import MainTitle from "@/components/shared/text/MainTitle.vue";

export default {
  name: "CardWithLine",
  components: {MainTitle, LineBlock},
  props: {
    item: {
      type: Object,
      required: true
    },
    fontFamily: {
      type: String,
      default: 'Eurostile'
    },
  }
}
</script>

<style scoped lang="scss">
  .card-with-line-container {
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    .text-content {
      white-space: pre-wrap;
    }
  }



  @media (max-width: 3024px){
    .card-with-line-container {
      column-gap: 24px;
    }
  }


  @media (max-width: 1600px) {
    .card-with-line-container {
      column-gap: 16px;
    }
  }
  @media (max-height: 800px) {
    .card-with-line-container {
      column-gap: 12px;
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {
    .card-with-line-container {
      column-gap: 16px;
    }
  }

  @media (max-width: 1133px) {
    .card-with-line-container {
      column-gap: 12px;
    }
  }

  @media (max-width: 769px) {
    .card-with-line-container {
      column-gap: 12px;
      &.is-active-history {
        .text-content {
          font-size: 14px;
        }
      }
      .text-content {
        font-size: 12px;
      }
    }
    //14
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
    //plus
  }

  @media (min-height: 600px) and (max-height: 630px){

    //8 plus
  }

  @media (max-width: 375px) {
    //se new
  }

  @media (max-width: 375px) and (min-height: 630px) {
    //x
  }


  @media (max-width: 320px) {
    //se old
  }

  @media (min-width: 3025px) {
    .card-with-line-container {
      column-gap: 56px;
    }
  }

</style>